// React
import React from 'react';

// Graphql
import { graphql, compose } from 'react-apollo';

// Queries
import queries from './queries';

// Translate
import { translate } from 'react-i18next';

// Views
import NavBarBlack from '../components/NavBarBlack';
import HeaderHome from './Header';
import SecondSection from './components/HomeSections/SecondSection';
import ThirdSection from './components/HomeSections/ThirdSection';
// import FourthSection from './components/HomeSections/FourthSection';
import FifthSection from '../components/ContactSection';
import FooterSection from '../components/FooterSection';
import HomeButtonSeparator from './components/HomeButtonSeparator';

// Style
import './style.sass';

const homeLinkButtonURL = 'https://calendly.com/c1do1/30min';

class HomeNew extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      t,
      generalQueries: { feedbackType, error },
    } = this.props;
    let feedbacks = {
      total_audios: 12174,
      total_common_mistakes: 1152,
      total_drawings: 14472,
      total_texts: 70611,
    };
    if (!error && feedbackType && feedbackType.length > 0)
      feedbacks = feedbackType[0];

    return (
      <div className="home-wrapper">
        <NavBarBlack t={t} />
        <HeaderHome t={t} />
        <SecondSection t={t} href={homeLinkButtonURL} />
        <ThirdSection t={t} />
        {/* <FourthSection t={t}  feedbacks={feedbacks} /> */}
        <FifthSection t={t} href={homeLinkButtonURL}/>
        <FooterSection t={t} />
      </div>
    );
  }
}

export default compose(
  graphql(queries.generalQueries, { name: 'generalQueries' }),
  translate('common')
)(HomeNew);
